import {
  ApolloError,
  FetchPolicy,
  useQuery,
  useReactiveVar,
} from '@apollo/client'
import { Application, Maybe, Role } from '@lib/graphql/__generated__/graphql'
import { GET_USER_ACCOUNT } from '@lib/graphql/queries/Organization'
import { organizationIdVar } from '@lib/graphql/variables/organizationId'
import { User } from '@lib/types/user'
import pathOr from 'ramda/src/pathOr'
import { useMemo } from 'react'

interface UseUserResponse {
  account: User
  roles: Role[]
  loading: boolean
  error: ApolloError
}

type UseUserParams = {
  fetchPolicy?: FetchPolicy
  skip?: boolean
}

const useUser: (params?: UseUserParams) => UseUserResponse = ({
  fetchPolicy,
  skip,
} = {}) => {
  const orgId = useReactiveVar(organizationIdVar)
  const { data, loading, error } = useQuery(GET_USER_ACCOUNT, {
    fetchPolicy,
    skip: skip || !orgId,
  })

  const roles = pathOr([], ['getCurrentUserAccount', 'roles'])(data)

  const account = useMemo(() => {
    const accountData = data?.getCurrentUserAccount
    return accountData
      ? {
          ...(accountData as Maybe<User>),
          permissionsNames:
            accountData?.permissions
              ?.filter((p) => p.application === Application.Havelock)
              ?.map((p) => p.name) ?? [],
        }
      : null
  }, [data?.getCurrentUserAccount])

  return {
    account,
    roles,
    loading,
    error,
  }
}

export default useUser
